// extracted by mini-css-extract-plugin
export default {"empty":"Index_empty__sVZkl","captcha":"Index_captcha__3SDh1","button":"Index_button__NrNfJ","action":"Index_action__psfHz","action_item":"Index_action_item__Fr1CN"};